import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main/main.component';
import { SectorCalendarComponent } from './main/components/sector-calendar/sector-calendar.component';
import { DayStatisticsComponent } from './main/components/day-statistics/day-statistics.component';

@NgModule({
  declarations: [MainComponent, SectorCalendarComponent, DayStatisticsComponent],
  imports: [CommonModule, MainRoutingModule, AppUiModule, SharedModule, FormsModule, ReactiveFormsModule],
  exports: [MainComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainModule {}
